// src/pages/Flyers/FlyerRightDrawer.tsx
import React from "react";
import { useTheme } from "@mui/material/styles";
import ActionOnRecord from "components/Records/ActionOnRecord";
import { moveItemsBetweenNodes } from "api/Campaigns/CampaignAPI";
import { getLinkedAddressesFromInteraction } from "api/Interactions/InteractionAPI";


interface FlyerRightDrawerProps {
  flyerId: number;
}

const FlyerRightDrawer: React.FC<FlyerRightDrawerProps> = ({
  flyerId,
}) => {
  const theme = useTheme();

  // --------------------------------------------------
  // Fetch people attached to the Flyer interaction
  // --------------------------------------------------
  const fetchAddresses = async () => {
    const addresses = await getLinkedAddressesFromInteraction("flyer", flyerId);
    
    return addresses.map((p: any) => ({
      id: p.id,
      primary: `${p.street_address}, ${p.city}`,
      secondary: ` ${p.post_code}, ${p.country}`,
    }));
  };

  // --------------------------------------------------
  // Send flyers = move addresses forward through pathway
  // --------------------------------------------------
  const handleSendFlyers = async (selected: any[]) => {
    if (!selected.length) return;

    await moveItemsBetweenNodes({
      item_field_name: "addresses",
      selected_items: selected.map(p => p.id),
      handle_name: "output-10",
      direction: "forward",
      interaction_id: flyerId,
      interaction_type: "flyer",
    });
    
  };
  
  return (
    <ActionOnRecord
      fetchData={fetchAddresses}
      onAction={handleSendFlyers}
      primaryColor={theme.custom.modules.interactions.primary.dark}
      textColor={theme.custom.base.text.primary.dark}
      actionLabel="Log Flyers"
    />
  );
};

export default FlyerRightDrawer;
